import BellIcon from '@heroicons/react/outline/BellIcon'
import HomeIcon from '@heroicons/react/outline/HomeIcon'
import LoginIcon from '@heroicons/react/outline/LoginIcon'
import NewspaperIcon from '@heroicons/react/outline/NewspaperIcon'
import SearchIcon from '@heroicons/react/outline/SearchIcon'
import UserCircleIcon from '@heroicons/react/outline/UserCircleIcon'
import UserGroupIcon from '@heroicons/react/outline/UserGroupIcon'
import ViewGridIcon from '@heroicons/react/outline/ViewGridIcon'
import * as BellSolidIcon from '@heroicons/react/solid/BellIcon'
import * as HomeSolidIcon from '@heroicons/react/solid/HomeIcon'
import * as NewspaperSolidIcon from '@heroicons/react/solid/NewspaperIcon'
import * as SearchSolidIcon from '@heroicons/react/solid/SearchIcon'
import * as UserCircleSolidIcon from '@heroicons/react/solid/UserCircleIcon'
import * as UserGroupSolidIcon from '@heroicons/react/solid/UserGroupIcon'
import * as ViewGridSolidIcon from '@heroicons/react/solid/ViewGridIcon'

import { SystemSpaceSlug } from '@tribeplatform/react-sdk/hooks'

export const enum MainMenuIcon {
  BellIcon = 'BellIcon',
  HomeIcon = 'HomeIcon',
  NewspaperIcon = 'NewspaperIcon',
  SearchIcon = 'SearchIcon',
  UserCircleIcon = 'UserCircleIcon',
  UserGroupIcon = 'UserGroupIcon',
  ViewGridIcon = 'ViewGridIcon',
}

export const SystemSpacesIcons = {
  [SystemSpaceSlug.HOME]: HomeIcon,
  [SystemSpaceSlug.SEARCH]: SearchIcon,
  [SystemSpaceSlug.NOTIFICATIONS]: BellIcon,
  [SystemSpaceSlug.PROFILE_SETTINGS]: UserCircleIcon,
  [SystemSpaceSlug.SIGNUP]: LoginIcon,
  [SystemSpaceSlug.LOGIN]: LoginIcon,
  [SystemSpaceSlug.ACCEPT_INVITATION]: LoginIcon,
  [SystemSpaceSlug.DIRECT_LOGIN]: LoginIcon,
  [SystemSpaceSlug.FORGOT_PASSWORD]: LoginIcon,
  [SystemSpaceSlug.JOIN_BY_INVITATION]: LoginIcon,
  [SystemSpaceSlug.RESET_PASSWORD]: LoginIcon,
  [SystemSpaceSlug.VERIFY_EMAIL]: LoginIcon,
  'default::members': UserGroupIcon,
  'default::spaces': ViewGridIcon,
}

export const mainMenuIcons = {
  [MainMenuIcon.BellIcon]: BellIcon,
  [MainMenuIcon.HomeIcon]: HomeIcon,
  [MainMenuIcon.NewspaperIcon]: NewspaperIcon,
  [MainMenuIcon.SearchIcon]: SearchIcon,
  [MainMenuIcon.UserCircleIcon]: UserCircleIcon,
  [MainMenuIcon.UserGroupIcon]: UserGroupIcon,
  [MainMenuIcon.ViewGridIcon]: ViewGridIcon,
}

export const mainMenuActiveIcons = {
  [MainMenuIcon.BellIcon]: BellSolidIcon,
  [MainMenuIcon.HomeIcon]: HomeSolidIcon,
  [MainMenuIcon.NewspaperIcon]: NewspaperSolidIcon,
  [MainMenuIcon.SearchIcon]: SearchSolidIcon,
  [MainMenuIcon.UserCircleIcon]: UserCircleSolidIcon,
  [MainMenuIcon.UserGroupIcon]: UserGroupSolidIcon,
  [MainMenuIcon.ViewGridIcon]: ViewGridSolidIcon,
}

export const enum MainMenuAction {
  OPEN_SPACE = 'OPEN_SPACE',
  OPEN_PROFILE = 'OPEN_PROFILE',
  OPEN_LINK = 'OPEN_LINK',
}
export type MainMenuItem = {
  enabled: boolean
  label: string
  action: MainMenuAction
  icon: string
  link?: string
  spaceSlug?: string
  entityId?: string
}
export const mainMenuDefaultItems: MainMenuItem[] = [
  {
    enabled: true,
    label: 'Home',
    action: MainMenuAction.OPEN_SPACE,
    icon: MainMenuIcon.HomeIcon,
    spaceSlug: 'default::home',
    link: null,
  },
  // {
  //   enabled: false,
  //   label: 'Explore',
  //   action: MainMenuAction.OPEN_PAGE,
  //   icon: MainMenuIcon.NewspaperIcon,
  //   spaceSlug: 'default::explore',
  //   link: null,
  // },
  {
    enabled: true,
    label: 'Members',
    action: MainMenuAction.OPEN_SPACE,
    icon: MainMenuIcon.UserGroupIcon,
    spaceSlug: 'default::members',
    link: null,
  },
  {
    enabled: true,
    label: 'Spaces',
    action: MainMenuAction.OPEN_SPACE,
    icon: MainMenuIcon.ViewGridIcon,
    spaceSlug: 'default::spaces',
    link: null,
  },
  {
    enabled: false,
    label: 'Profile',
    action: MainMenuAction.OPEN_PROFILE,
    icon: MainMenuIcon.UserCircleIcon,
    spaceSlug: null,
    link: null,
  },
]

export const mainMenuActions = [
  {
    label: 'Show Home',
    action: MainMenuAction.OPEN_SPACE,
    spaceSlug: 'default::home',
    link: null,
  },
  {
    label: 'Show Explore',
    action: MainMenuAction.OPEN_SPACE,
    spaceSlug: 'default::explore',
    link: null,
  },
  {
    label: 'Show All Members',
    action: MainMenuAction.OPEN_SPACE,
    spaceSlug: 'default::members',
    link: null,
  },
  {
    label: 'Show All Spaces',
    action: MainMenuAction.OPEN_SPACE,
    spaceSlug: 'default::spaces',
    link: null,
  },
  {
    label: 'Show All Collections',
    action: MainMenuAction.OPEN_SPACE,
    spaceSlug: 'default::collections',
    link: null,
  },
  {
    label: 'Show Profile',
    action: MainMenuAction.OPEN_PROFILE,
    spaceSlug: null,
    link: null,
  },
]
